import { createUseStyles } from '@glu/theming';

export default createUseStyles({
  root: {
    fontSize: 12,
    lineHeight: 1.2,
    color: '#757575',
    borderTop: '1px solid #cccccc',
    padding: '10px 20px 0 20px',
    margin: ' 10px 0 0 0'
  }
});
